export default {
  SET_EVENTS (state, events) {
    state.events = events
  },
  SET_QUICKLINKS (state, quicklinks) {
    state.quicklinks = quicklinks
  },
  SET_DASHBOARDEVENTS (state, dashboardevents) {
    state.dashboardevents = dashboardevents
  },
  SET_OWNERS_BY_EVENTID (state, ownersByEventId) {
    state.ownersByEventId = ownersByEventId
  }
}
